import { render, staticRenderFns } from "./mileage-fee.vue?vue&type=template&id=05b5981c&scoped=true&"
import script from "./mileage-fee.vue?vue&type=script&lang=js&"
export * from "./mileage-fee.vue?vue&type=script&lang=js&"
import style0 from "./mileage-fee.vue?vue&type=style&index=0&id=05b5981c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5981c",
  null
  
)

export default component.exports